/*
  VIX Motion — Scroll Reveal Observer
  Phase 1 global design pass (2026-04-16)

  Drives the [data-reveal] and [data-reveal-stagger] animation system
  defined in vix-motion.css. Uses IntersectionObserver — no framework,
  no dependencies. Animates once per element, then stops observing.

  Honors prefers-reduced-motion via CSS.
*/
(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markAllVisible() {
    var all = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.add('is-visible');
    }
  }

  function init() {
    // If reduced motion is preferred, or IntersectionObserver is unavailable,
    // mark everything visible immediately so nothing hides.
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      markAllVisible();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    var targets = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');
    for (var i = 0; i < targets.length; i++) {
      observer.observe(targets[i]);
    }

    // Handle elements added to the DOM after init (defensive)
    // Rare in a Shopify theme, but cheap insurance.
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;
            if (node.matches && node.matches('[data-reveal], [data-reveal-stagger]')) {
              observer.observe(node);
            }
            if (node.querySelectorAll) {
              var inner = node.querySelectorAll('[data-reveal], [data-reveal-stagger]');
              for (var j = 0; j < inner.length; j++) observer.observe(inner[j]);
            }
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
